
import React from 'react';
import { motion } from 'framer-motion';
import { Button } from '@/components/ui/button';
import { useIsMobile } from '@/hooks/use-mobile';
import { sparkleAnimation } from './animations/contributionAnimations';

interface PresetAmountSelectorProps {
  selectedAmount: number | null;
  onAmountSelect: (amount: number) => void;
}

const PresetAmountSelector: React.FC<PresetAmountSelectorProps> = ({
  selectedAmount,
  onAmountSelect,
}) => {
  const isMobile = useIsMobile();
  
  const presetAmounts = [
    { value: 0, display: '0' },
    { value: 500000, display: '500.000' },
    { value: 1000000, display: '1.000.000' },
    { value: 2000000, display: '2.000.000' },
    { value: 3000000, display: '3.000.000' }
  ];

  return (
    <div className="grid grid-cols-2 md:grid-cols-5 gap-3 md:gap-4">
      {presetAmounts.map((amount) => (
        <motion.div
          key={amount.value}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.97 }}
          variants={sparkleAnimation}
          animate={selectedAmount === amount.value ? "animate" : undefined}
        >
          <Button
            type="button"
            variant={selectedAmount === amount.value ? "default" : "outline"}
            className={`w-full ${isMobile ? 'h-12 text-sm font-medium' : 'h-14 text-base font-medium'} 
              relative overflow-hidden ${
              selectedAmount === amount.value 
                ? 'bg-gradient-to-r from-blue-500 to-sky-500 text-white border-blue-500 shadow-md' 
                : 'border-blue-200 text-blue-700 hover:bg-blue-50'
            } transition-all duration-300`}
            onClick={() => onAmountSelect(amount.value)}
          >
            {selectedAmount === amount.value && (
              <motion.span
                className="absolute inset-0 bg-white opacity-10"
                initial={{ scale: 0, borderRadius: '100%' }}
                animate={{ scale: 1.5, borderRadius: '0%', opacity: 0 }}
                transition={{ duration: 0.6 }}
              />
            )}
            {amount.display}₫
          </Button>
        </motion.div>
      ))}
    </div>
  );
};

export default PresetAmountSelector;
